import {Map} from 'immutable';
import _ from 'lodash';

const OPEN_SUBMENU = 'OPEN_SUBMENU';
const CLOSE_SUBMENU = 'CLOSE_SUBMENU';

const initialState = new Map({
    submenu: [],
});

export default function reducer(state = initialState, action = {}) {
    let submenu;
    switch (action.type) {
        case OPEN_SUBMENU:
            submenu = _.clone(state.get('submenu'));
            submenu.push(action.payload);
            return state.set('submenu', submenu);
        case CLOSE_SUBMENU:
            submenu = _.clone(state.get('submenu'));
            submenu.splice(-1, 1);
            return state.set('submenu', submenu);
    }
    return state;
}

export const openSubmenu = (submenu) => async (dispatch) => {
    dispatch({type: OPEN_SUBMENU, payload: submenu});
};

export const closeSubmenu = (submenu) => async (dispatch) => {
    dispatch({type: CLOSE_SUBMENU});
};


// WEBPACK FOOTER //
// ./src/store/reducers/menu.js